<template>
  <div v-observer:subtree.childList="mutationsHandler" ref="container" :class="containerClass"/>
</template>

<script>

import { observer } from 'vue-mutation-observer'

export default {
  directives: {
    observer
  },
  data () {
    return {
      toastCnt: 0
    }
  },
  computed: {
    containerClass () {
      return {
        'toast-container-zindex': this.toastCnt < 1,
        'toast-container-zindex-active': this.toastCnt > 0
      }
    }
  },
  created () {
  },
  updated () {

  },
  beforeMount () {
  },
  methods: {
    mutationsHandler (mutations) {
      var toastNodeList = this.$refs.container.querySelectorAll('.Vue-Toastification__toast')
      this.$set(this, 'toastCnt', toastNodeList.length)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/_common/mmp-toast/MmpToast.vue